<template>
    <ElementFilter v-if="filterFlag" :filter="filters" @dropFilters="dropFilters" @setFilters="e => setFilters(e)" @close="filterFlag = false" />
    <div class="w-[90%] mx-auto mt-[20px]">
        
        <div v-if="errorValidationFlag" class="absolute flex flex-col left-[50%] translate-x-[-50%] px-[20px] justify-evenly top-[50%] translate-y-[-50%] ml-[150px] rounded-[10px] w-[300px] h-[200px] bg-[#252526]">
            <div class="flex justify-center items-center">
                <div class="text-white text-[16px] text-center font-semibold">
                    В тренуванні є незаповнені поля або елементи з не вказаним часом
                </div>
            </div>
            <div @click="errorValidationFlag = false" class="bg-[#BD9135] text-center cursor-pointer text-white font-semibold py-[5px] rounded-lg mt-[15px]">
                OK
            </div>
        </div>
        <div class="flex flex-col justify-between">
            <!-- <div class="line border-[1px] rounded-[10px] w-full flex h-[35px] overflow-hidden">
                <div 
                    v-for="(el, id) in elements" 
                    @click="elementViewFlag = true; selectedElement = el" 
                    class="h-full flex justify-center items-center cursor-pointer px-[10px]" 
                    :style="{width: isElementsWithoutTime() ? (100 / elements.length) + '%' : ((100 * el.time) / getFulltimeOfElements()) + '%', backgroundColor: id % 2 == 0 ? '#BD9135' : '#000'}"
                    :class="{'opacity-[0.6]' : !el.time}"
                >
                    <div class="text-white text-center text-[1rem] flex items-center overflow-hidden whitespace-nowrap overflow-ellipsis">
                        
                        <div>
                            {{ 100 / elements.length > 10 ? el.name : el.name[0] }}
                        </div>

                        <svg v-if="!el.time" class="ml-[10px]" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_23_10)">
                            <circle cx="8.5" cy="8.5" r="6.25" stroke="white" stroke-width="1.5"/>
                            <path d="M8.5 6V8.5L9.75 9.75" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </g>
                            <path d="M16 1L1 16" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                            <defs>
                            <clipPath id="clip0_23_10">
                            <rect width="15" height="15" fill="white" transform="translate(1 1)"/>
                            </clipPath>
                            </defs>
                        </svg>


                    </div>
                </div>


                <div @click="showElements = true" class="text-center w-[30px] h-full cursor-pointer text-[21px] text-white">+</div>
            </div> -->
            <div class="text-[#BD9135] font-bold text-[14px] mb-[6px]">Команда</div>
            <div class="line border-[1px] rounded-[10px] w-full flex h-[35px] overflow-hidden">
                <draggable 
                    class="line w-full flex h-[35px] overflow-hidden" 
                    v-model="elements" group="training-elements" 
                    @start="drag=true"  
                    @end="drag=false" 
                    item-key="current_id"
                >
                    <template #item="{element, index}">
                        <div 
                            @click="elementViewFlag = true; selectedElement = element; activeTimeline = 'player'" 
                            class="relative h-full flex justify-center items-center cursor-pointer px-[10px] bg-[#BD9135] border-x-[1px] border-black" 
                            :style="getPlayerElementStyle(element)"
                            :class="{'opacity-[0.6]' : !element.time}"
                        >
                        <button
                            v-if="!isGoalkeeperTrainer"
                            class="absolute right-1 top-[50%] translate-y-[-50%] w-[18px] h-[18px] rounded-full bg-[#252526] text-white text-[12px] flex items-center justify-center hover:bg-[#DA4167]"
                            @click.stop="deleteElementFromTimeline(element, 'player')"
                            title="Видалити елемент"
                        >×</button>
                        <div class="text-black text-center text-[1rem] flex items-center overflow-hidden whitespace-nowrap overflow-ellipsis">
                            <div>{{ getElementDisplayName(element) }}</div>
                            <svg v-if="!element.time" class="ml-[10px]" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_23_10)">
                                <circle cx="8.5" cy="8.5" r="6.25" stroke="black" stroke-width="1.5"/>
                                <path d="M8.5 6V8.5L9.75 9.75" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </g>
                                <path d="M16 1L1 16" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
                                <defs>
                                <clipPath id="clip0_23_10">
                                <rect width="15" height="15" fill="black" transform="translate(1 1)"/>
                                </clipPath>
                                </defs>
                            </svg>
                        </div>
                    </div>
                    </template>
                    
                </draggable>
                <div v-if="!isGoalkeeperTrainer && !isIndividualTrainer" @click="activeTimeline = 'player'; showElements = true; elementViewFlag = false" class="text-center w-[30px] h-full cursor-pointer text-[21px] text-white">+</div>
            </div>
            <div class="text-white text-center mt-[12px]">{{timelineTime}} ЗАГАЛЬНИЙ ЧАС</div>

            <div class="text-[#339989] font-bold text-[14px] mt-[20px] mb-[6px]">Індивідуальна робота</div>
            <div class="flex items-stretch">
                <div class="line border-[1px] rounded-[10px] w-full relative h-[35px] overflow-hidden">
                    <div
                        v-for="element in goalkeeperElements"
                        :key="element.current_id"
                        @mousedown="startDragGk($event, element)"
                        @click="elementViewFlag = true; selectedElement = element; activeTimeline = 'goalkeeper'"
                        class="absolute top-0 h-full flex justify-center items-center cursor-grab px-[10px] bg-[#339989] border-x-[1px] border-black select-none"
                        :style="getGkRailStyle(element)"
                        :class="{'opacity-[0.6]' : !element.time, 'bg-[#BD9135]': selectedElement.current_id === element.current_id && elementViewFlag, 'z-[10]': draggingGkId === element.current_id}"
                        :title="element.name"
                    >
                        <button
                            class="absolute right-1 top-[50%] translate-y-[-50%] w-[18px] h-[18px] rounded-full bg-[#252526] text-white text-[12px] flex items-center justify-center hover:bg-[#DA4167]"
                            @click.stop="deleteElementFromTimeline(element, 'goalkeeper')"
                            title="Видалити елемент"
                        >×</button>
                        <div class="text-black text-center text-[1rem] flex items-center overflow-hidden whitespace-nowrap overflow-ellipsis">
                            <div>{{ getElementDisplayName(element) }}</div>
                            <svg v-if="!element.time" class="ml-[10px]" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_23_10)">
                                <circle cx="8.5" cy="8.5" r="6.25" stroke="black" stroke-width="1.5"/>
                                <path d="M8.5 6V8.5L9.75 9.75" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </g>
                                <path d="M16 1L1 16" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
                                <defs>
                                <clipPath id="clip0_23_10">
                                <rect width="15" height="15" fill="black" transform="translate(1 1)"/>
                                </clipPath>
                                </defs>
                            </svg>
                        </div>
                    </div>
                </div>

                <div v-if="canEditGoalkeeperTimeline" @click="activeTimeline = 'goalkeeper'; showElements = true; elementViewFlag = false" class="text-center w-[30px] h-full cursor-pointer text-[21px] text-white">+</div>
            </div>
            <div class="text-white text-center mt-[12px]">{{goalkeeperTimelineTime}} ЗАГАЛЬНИЙ ЧАС</div>

            <div v-if="!showElements && !elementViewFlag">
                <div class="training-form-content">
                    <div class="mr-[20px]">
                        <div>
                            <div class="w-[100%] flex flex-col items-start justify-start mb-3">
                                <div class="text-[#BD9135] text-[14px] font-bold">Назва тренування</div>
                                <input 
                                    v-model="trainingName" 
                                    class="bg-[#252526] outline-none text-white text-[18px] w-[100%] py-[5px] px-[5px] rounded-[6px]" 
                                    placeholder="Введіть назву..."
                                    :class="{
                                        'border-[#DA4167] border-[3px]': !validation.name
                                    }"         
                                >    
                                <div v-html="nameValidationText"></div>
                            </div>
                            <div class="w-[100%] flex flex-col items-start justify-start mb-3">
                                <div class="text-[#BD9135] text-[14px] font-bold">Вікова група</div>
                                <select 
                                    v-model="trainingAgeGroup" 
                                    class="bg-[#252526] outline-none text-white text-[18px] w-[100%] py-[5px] px-[5px] rounded-[6px]"
                                    :class="{
                                        'text-[#8C8C8C]': trainingAgeGroup === '',
                                        'border-[#DA4167] border-[3px] ': !validation.ageGroup
                                    }"    
                                >
                                    <option value="" disabled>Виберіть вікову категорію</option>
                                    <option class="text-white" value="6_years">6 років</option>
                                    <option class="text-white" value="7_years">7 років</option>
                                    <option class="text-white" value="8_years">8 років</option>
                                    <option class="text-white" value="9_years">9 років</option>
                                    <option class="text-white" value="10_years">10 років</option>
                                    <option class="text-white" value="11_years">11 років</option>
                                    <option class="text-white" value="12_years">12 років</option>
                                    <option class="text-white" value="13_years">13 років</option>
                                    <option class="text-white" value="14_years">14 років</option>
                                    <option class="text-white" value="15_years">15 років</option>
                                    <option class="text-white" value="16_years">16 років</option>
                                    <option class="text-white" value="17_years">17 років</option>
                                    <option class="text-white" value="18_years">18 років</option>
                                    <option class="text-white" value="19_years">19 років</option>
                                    <option class="text-white" value="20_years">20 років</option>
                                    <option class="text-white" value="21_years">21 років</option>
                                    <option class="text-white" value="22_years">22 років</option>
                                    <option class="text-white" value="23_years">23 років</option>
                                    <option class="text-white" value="main_team">Основна команда</option>
                                </select>    
                            </div>
                        </div>
                        <div>
                            <div class="text-[#BD9135] text-[14px] font-bold">Нотатка</div>
                            <textarea 
                                v-model="trainingDescription" 
                                :disabled="isGoalkeeperTrainer || isIndividualTrainer"
                                class="w-full h-[410px] outline-none bg-[#252526] text-white rounded-[10px] p-[10px]" 
                                placeholder="Введіт опис..."
                                :class="{'opacity-50 cursor-not-allowed': isGoalkeeperTrainer || isIndividualTrainer}"
                            ></textarea>
                        </div>
                    </div>
                    <div class="">
                        <div class="w-[100%] flex flex-col items-start justify-start mb-3">
                            <div class="text-[#BD9135] text-[14px] font-bold">Інвентар</div>
                            <input 
                                v-model="inventory" 
                                class="bg-[#252526] outline-none text-white text-[18px] w-[100%] py-[5px] px-[5px] rounded-[6px]" 
                                placeholder="Опишіть інвентар"        
                            > 
                        </div>
                        <div class="w-[100%] flex flex-col items-start justify-start mb-3">
                            <div class="text-[#BD9135] text-[14px] font-bold">Напрям</div>
                            <!-- <select
                                v-model="direction" 
                                class="bg-[#252526] outline-none text-white text-[18px] w-[100%] py-[5px] px-[5px] rounded-[6px]"  
                            >
                                <option value="" disabled>Виберіть напрям тренування</option>
                                <option class="text-white" value="physical">фізичне</option>
                                <option class="text-white" value="technical">технічне</option>
                                <option class="text-white" value="tactical">тактичне</option>
                                <option class="text-white" value="tech_tactical">техніко/тактичне</option>
                                <option class="text-white" value="psycho_fisical">психофізіологічне</option>
                            </select>     -->
                            <div class="flex gap-[10px] w-[300px] overflow-auto mt-[10px]">
                                <div v-for="direction in trainingOrientation" :style="[`background-color: ${direction.color}; width: max-content;`]" class="rounded-[6px] text-white text-[12px] px-[10px] py-[3px]">
                                    {{ direction.name }} ({{ direction.averagePercent.toFixed(2) }})
                                </div>
                            </div>
                        </div>
                        <div class="w-[100%] flex flex-col items-start justify-start mb-3">
                            <div class="text-[#BD9135] text-[14px] font-bold">Програма тренувань</div>
                            <select 
                                v-model="selectedProgram"
                                class="bg-[#252526] outline-none text-white text-[18px] w-[100%] py-[5px] px-[5px] rounded-[6px]"  
                            >
                                <option value="">Виберіть програму</option>
                                <option v-for="program in allPrograms" class="text-white" :value="program.id">{{ program.name }}</option>
                            </select>    
                        </div>
                        <div class="w-[100%] flex flex-col items-start justify-start mb-3">
                            <div class="text-[#BD9135] text-[14px] font-bold">Сезон</div>
                            <select 
                                v-model="selectedSeason"
                                class="bg-[#252526] outline-none text-white text-[18px] w-[100%] py-[5px] px-[5px] rounded-[6px]"  
                            >
                                <option value="">Виберіть сезон</option>
                                <option v-for="value in allSeasons" class="text-white" :value="value.id">{{ value.name }}</option>
                            </select>    
                        </div>
                        <div class="w-[100%] flex flex-col items-start justify-start mb-3">
                            <div class="text-[#BD9135] text-[14px] font-bold">Макроцикл</div>
                            <select 
                                v-model="selectedMesocycle"
                                class="bg-[#252526] outline-none text-white text-[18px] w-[100%] py-[5px] px-[5px] rounded-[6px]"  
                            >
                                <option value="">Виберіть макроцикл</option>
                                <option v-for="value in allMesocycles" class="text-white" :value="value.id">{{ value.name }}</option>
                            </select>    
                        </div>
                        <div class="w-[100%] flex flex-col items-start justify-start mb-3">
                            <div class="text-[#BD9135] text-[14px] font-bold">Мікроцикл</div>
                            <select 
                                v-model="selectedMicrocycle"
                                class="bg-[#252526] outline-none text-white text-[18px] w-[100%] py-[5px] px-[5px] rounded-[6px]"  
                            >
                                <option value="">Виберіть мікроцикл</option>
                                <option v-for="value in allMicrocycles" class="text-white" :value="value.id">{{ value.name }}</option>
                            </select>    
                        </div>
                        <div class="w-[100%] flex flex-col items-start justify-start mb-3">
                            <div class="text-[#BD9135] text-[14px] font-bold">Дата тренування</div>
                            <input 
                                class="bg-[#252526] outline-none text-white text-[18px] w-[100%] py-[5px] px-[5px] rounded-[6px]" 
                                placeholder="Опишіть інвентар"        
                                type="date"
                                v-model="trainingDate"
                            > 
                        </div>
                        <div>
                            <div class="text-[#BD9135] text-[14px] font-bold">Виберіть тренування</div>

                            <div class="mt-[10px] h-[150px] overflow-y-auto">
                                <div 
                                    v-for="training in trainingsByDate" 
                                    v-if="trainingsByDate.length" 
                                    @click="selectTrainingEvent(training)" 
                                    :style="[`background-color: ${selectedTrainingEvent?.training_id == training.training_id ? '#8FC408' : '#BD9135'}`]"
                                    class="mb-[10px] cursor-pointer font-bold text-black rounded-md text-center py-[2px]"
                                >{{ training.start_time }} {{ training.group_label }}</div>
                                <div v-else class="text-gray-500 text-center">Немає запланованих тренувань</div>
                            </div>
                        </div>
                        <!-- date.split('T')[0].split('-').reverse().join('.') -->
                        <!-- <div class="w-[100%] flex flex-col items-start justify-start">
                            <div class="bg-[#252526] text-[#BD9135] cursor-pointer mt-[20px] border-[1px] text-center border-[#BD9135] text-[18px] w-[100%] py-[3px] px-[5px] rounded-[6px]">Додати до програми</div>
                        </div> -->
                        <div class="w-[100%] flex flex-col items-start justify-start">
                            <div v-if="currentAdminRole != 'supervisor'" @click="updateTrainingSummary" class="bg-[#BD9135] text-[#252526] cursor-pointer mt-[20px] border-[1px] text-center border-[#BD9135] text-[18px] w-[100%] py-[3px] px-[5px] rounded-[6px]">Зберегти</div>
                            <!-- <div @click="$router.push('/trainings-constructor')" class="bg-[#BD9135] text-[#252526] cursor-pointer mt-[20px] border-[1px] text-center border-[#BD9135] text-[18px] w-[100%] py-[3px] px-[5px] rounded-[6px]">Назад</div> -->
                            <div @click="$router.go(-1)" class="bg-[#BD9135] text-[#252526] cursor-pointer mt-[20px] border-[1px] text-center border-[#BD9135] text-[18px] w-[100%] py-[3px] px-[5px] rounded-[6px]">Назад</div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else-if="showElements && !elementViewFlag">
                <!-- <div class="w-[100%] flex justify-between items-center">
                    <div class="search-bar flex items-center border-[#FFF] border-[1px] bg-[#FFF] bg-opacity-30 px-[10px] rounded-[6px]">
                        <img src="@/assets/icons/magnify_icon.svg" class="w-3 h-3">
                        <input v-model="searchQuery" class="text-[#FFF] text-[14px] bg-transparent rounded-md px-2 py-[3.5px] placeholder:text-[#FFF] outline-none w-[250px] " placeholder="Пошук..." type="text">
                    </div>
                    <div class="w-full ml-[30px] flex items-center ">
                        <div class="text-[#8C8C8C] w-[250px] text-start font-medium relative text-[14px]">
                            Відображення елементів
                            <span v-if="elementsViewTable" class="text-[#8FC408]">таблиця</span>
                            <span v-else class="text-[#FA1367]">групи</span>
                        </div>
                        <div class="ml-[20px] relative top-[4px]">
                            <IphoneSwitch :isOnValue="elementsViewTable" @change="elementsViewTable = !elementsViewTable"/>
                        </div>
                    </div>
                    <div class="w-max flex justify-end items-center">
                        <div @click="filterFlag = true" class="flex items-center cursor-pointer">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.85746 12.5061C6.36901 10.6456 4.59564 8.59915 3.62734 7.44867C3.3276 7.09253 3.22938 6.8319 3.17033 6.3728C2.96811 4.8008 2.86701 4.0148 3.32795 3.5074C3.7889 3 4.60404 3 6.23433 3H17.7657C19.396 3 20.2111 3 20.672 3.5074C21.133 4.0148 21.0319 4.8008 20.8297 6.37281C20.7706 6.83191 20.6724 7.09254 20.3726 7.44867C19.403 8.60062 17.6261 10.6507 15.1326 12.5135C14.907 12.6821 14.7583 12.9567 14.7307 13.2614C14.4837 15.992 14.2559 17.4876 14.1141 18.2442C13.8853 19.4657 12.1532 20.2006 11.226 20.8563C10.6741 21.2466 10.0043 20.782 9.93278 20.1778C9.79643 19.0261 9.53961 16.6864 9.25927 13.2614C9.23409 12.9539 9.08486 12.6761 8.85746 12.5061Z" stroke="#FFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <div class="ml-[20px] flex items-center w-[110px] justify-between mr-[140px] text-[#FFF]">
                            <img @click="prevPage" src="@/assets/icons/left_arrow.svg" class="cursor-pointer">
                            <div class="flex mx-[20px]">Сторінка: <input v-model="page" type="number" class="bg-transparent mx-2 w-[5ch] outline-none px-1"> / <span class="ml-[10px]">{{ maxPage }}</span></div>
                            <img @click="nextPage" src="@/assets/icons/right_arrow.svg" class="cursor-pointer">
                        </div>
                        <div @click="showElements = false" class="bg-[#BD9135] text-[#252526] cursor-pointer w-[220px] border-[1px] text-center border-[#BD9135] text-[18px] py-[3px] px-[5px] rounded-[6px]">Назад</div>
                    </div>
                </div> -->

                <div class="search-header mt-[20px]">
                    <div class="search-header__row">
                        <div class="search-header__sub-row">
                            <div class="search-bar">
                                <SearchInput :modelValue="searchQuery" @update:modelValue="e => searchQuery = e" />
                                <div 
                                    class="ml-[60px] flex items-center justify-between mr-[60px] text-[#FFF]">
                                    <!-- <img @click="prevPage" src="@/assets/icons/left_arrow.svg" class="cursor-pointer"> -->
                                    <div class="w-[36px] h-[36px] flex justify-center items-center cursor-pointer" @click="prevPage" >
                                        <svg width="35" height="34" viewBox="0 0 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="1.28613" y="0.5" width="33" height="33" rx="5.5" stroke="#474849"/>
                                            <path d="M11.7139 17L20.821 9.63878L20.821 24.3612L11.7139 17Z" fill="#474849"/>
                                        </svg>
        
                                    </div>
                                    <div class="flex mx-[10px]"><input v-model="page" type="number" class="bg-transparent border-[#474849] border-[1px] text-[12px] w-[34px] h-[34px] outline-none px-1 text-center rounded-[6px] mr-[10px]"> <span class="text-[10px] flex justify-center items-center">/</span> <span class="ml-[10px] border-[#474849] flex justify-center items-center bg-transparent border-[1px] w-[34px] h-[34px] text-[12px] outline-none px-1 text-center rounded-[6px] ">{{ maxPage }}</span></div>
                                    <!-- <img @click="nextPage" src="@/assets/icons/right_arrow.svg" class="cursor-pointer"> -->
                                    <div class="w-[36px] h-[36px] flex justify-center items-center cursor-pointer" @click="nextPage">
                                        <svg width="35" height="34" viewBox="0 0 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="0.857422" y="0.5" width="33" height="33" rx="5.5" stroke="#474849"/>
                                            <path d="M23.4287 17L14.3216 9.63878L14.3216 24.3612L23.4287 17Z" fill="#474849"/>
                                        </svg>
        
                                    </div>
                                </div>
                            </div>
                            <div class="w-full flex items-center ">
                                <!-- <div class="flex items-center cursor-pointer w-[24px] h-[24px] mr-[10px]" @click="filterFlag = true">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8.85746 12.5061C6.36901 10.6456 4.59564 8.59915 3.62734 7.44867C3.3276 7.09253 3.22938 6.8319 3.17033 6.3728C2.96811 4.8008 2.86701 4.0148 3.32795 3.5074C3.7889 3 4.60404 3 6.23433 3H17.7657C19.396 3 20.2111 3 20.672 3.5074C21.133 4.0148 21.0319 4.8008 20.8297 6.37281C20.7706 6.83191 20.6724 7.09254 20.3726 7.44867C19.403 8.60062 17.6261 10.6507 15.1326 12.5135C14.907 12.6821 14.7583 12.9567 14.7307 13.2614C14.4837 15.992 14.2559 17.4876 14.1141 18.2442C13.8853 19.4657 12.1532 20.2006 11.226 20.8563C10.6741 21.2466 10.0043 20.782 9.93278 20.1778C9.79643 19.0261 9.53961 16.6864 9.25927 13.2614C9.23409 12.9539 9.08486 12.6761 8.85746 12.5061Z" stroke="#FFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div> -->
        
                                <div class="flex items-center gap-[20px] cursor-pointer">
                                    <svg @click="filterFlag = true" width="35" height="34" viewBox="0 0 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="0.713867" y="0.5" width="33" height="33" rx="5.5" stroke="#474849"/>
                                        <path d="M11.7506 15.0363V9.48662C11.7506 9.30547 11.6787 9.13174 11.5506 9.00365C11.4225 8.87555 11.2487 8.80359 11.0676 8.80359C10.8864 8.80359 10.7127 8.87555 10.5846 9.00365C10.4565 9.13174 10.3845 9.30547 10.3845 9.48662V15.0363C9.79685 15.1868 9.27595 15.5286 8.90397 16.0078C8.53198 16.487 8.33008 17.0764 8.33008 17.6831C8.33008 18.2897 8.53198 18.8791 8.90397 19.3583C9.27595 19.8376 9.79685 20.1793 10.3845 20.3298V24.5134C10.3845 24.6946 10.4565 24.8683 10.5846 24.9964C10.7127 25.1245 10.8864 25.1964 11.0676 25.1964C11.2487 25.1964 11.4225 25.1245 11.5506 24.9964C11.6787 24.8683 11.7506 24.6946 11.7506 24.5134V20.3298C12.3383 20.1793 12.8592 19.8376 13.2312 19.3583C13.6032 18.8791 13.8051 18.2897 13.8051 17.6831C13.8051 17.0764 13.6032 16.487 13.2312 16.0078C12.8592 15.5286 12.3383 15.1868 11.7506 15.0363ZM11.0676 19.0491C10.7974 19.0491 10.5333 18.969 10.3086 18.8189C10.084 18.6688 9.90889 18.4554 9.80549 18.2058C9.7021 17.9562 9.67505 17.6815 9.72776 17.4165C9.78047 17.1516 9.91057 16.9081 10.1016 16.7171C10.2927 16.526 10.5361 16.3959 10.8011 16.3432C11.0661 16.2905 11.3407 16.3176 11.5904 16.421C11.84 16.5244 12.0533 16.6995 12.2034 16.9241C12.3535 17.1488 12.4336 17.4129 12.4336 17.6831C12.4336 18.0454 12.2897 18.3928 12.0335 18.649C11.7773 18.9052 11.4299 19.0491 11.0676 19.0491ZM17.8979 10.9381V9.48662C17.8979 9.30547 17.826 9.13174 17.6979 9.00365C17.5698 8.87555 17.3961 8.80359 17.2149 8.80359C17.0337 8.80359 16.86 8.87555 16.7319 9.00365C16.6038 9.13174 16.5319 9.30547 16.5319 9.48662V10.9381C15.9442 11.0885 15.4233 11.4303 15.0513 11.9096C14.6793 12.3888 14.4774 12.9782 14.4774 13.5848C14.4774 14.1915 14.6793 14.7809 15.0513 15.2601C15.4233 15.7393 15.9442 16.0811 16.5319 16.2316V24.5134C16.5319 24.6946 16.6038 24.8683 16.7319 24.9964C16.86 25.1245 17.0337 25.1964 17.2149 25.1964C17.3961 25.1964 17.5698 25.1245 17.6979 24.9964C17.826 24.8683 17.8979 24.6946 17.8979 24.5134V16.2316C18.4856 16.0811 19.0065 15.7393 19.3785 15.2601C19.7505 14.7809 19.9524 14.1915 19.9524 13.5848C19.9524 12.9782 19.7505 12.3888 19.3785 11.9096C19.0065 11.4303 18.4856 11.0885 17.8979 10.9381ZM17.2149 14.9509C16.9447 14.9509 16.6806 14.8708 16.456 14.7207C16.2313 14.5706 16.0562 14.3572 15.9528 14.1076C15.8494 13.858 15.8224 13.5833 15.8751 13.3183C15.9278 13.0533 16.0579 12.8099 16.2489 12.6189C16.44 12.4278 16.6834 12.2977 16.9484 12.245C17.2134 12.1923 17.4881 12.2194 17.7377 12.3228C17.9873 12.4261 18.2006 12.6012 18.3507 12.8259C18.5009 13.0505 18.581 13.3147 18.581 13.5848C18.581 13.9471 18.437 14.2946 18.1809 14.5508C17.9247 14.807 17.5772 14.9509 17.2149 14.9509ZM26.0944 20.4152C26.0938 19.8095 25.8923 19.2211 25.5215 18.7421C25.1507 18.2631 24.6315 17.9207 24.0453 17.7684V9.48662C24.0453 9.30547 23.9733 9.13174 23.8452 9.00365C23.7171 8.87555 23.5434 8.80359 23.3622 8.80359C23.1811 8.80359 23.0073 8.87555 22.8792 9.00365C22.7511 9.13174 22.6792 9.30547 22.6792 9.48662V17.7684C22.0915 17.9189 21.5706 18.2607 21.1986 18.7399C20.8266 19.2191 20.6247 19.8085 20.6247 20.4152C20.6247 21.0218 20.8266 21.6112 21.1986 22.0905C21.5706 22.5697 22.0915 22.9115 22.6792 23.062V24.5134C22.6792 24.6946 22.7511 24.8683 22.8792 24.9964C23.0073 25.1245 23.1811 25.1964 23.3622 25.1964C23.5434 25.1964 23.7171 25.1245 23.8452 24.9964C23.9733 24.8683 24.0453 24.6946 24.0453 24.5134V23.062C24.6315 22.9097 25.1507 22.5672 25.5215 22.0883C25.8923 21.6093 26.0938 21.0209 26.0944 20.4152ZM23.3622 21.7813C23.092 21.7813 22.8279 21.7011 22.6033 21.551C22.3786 21.4009 22.2035 21.1876 22.1001 20.938C21.9967 20.6884 21.9697 20.4137 22.0224 20.1487C22.0751 19.8837 22.2052 19.6403 22.3963 19.4492C22.5873 19.2582 22.8307 19.1281 23.0957 19.0754C23.3607 19.0227 23.6354 19.0497 23.885 19.1531C24.1346 19.2565 24.348 19.4316 24.4981 19.6562C24.6482 19.8809 24.7283 20.145 24.7283 20.4152C24.7283 20.7775 24.5844 21.125 24.3282 21.3812C24.072 21.6373 23.7245 21.7813 23.3622 21.7813Z" fill="#474849"/>
                                    </svg>
        
                                    <svg @click="elementsViewTable = true" width="35" height="34" viewBox="0 0 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="1.42871" y="0.5" width="33" height="33" rx="5.5" stroke="#474849"/>
                                        <path d="M27.946 7.89294H7.9103C7.42722 7.89294 6.96394 8.08484 6.62235 8.42643C6.28077 8.76801 6.08887 9.2313 6.08887 9.71437V24.2858C6.08887 24.7689 6.28077 25.2322 6.62235 25.5737C6.96394 25.9153 7.42722 26.1072 7.9103 26.1072H27.946C28.4291 26.1072 28.8924 25.9153 29.234 25.5737C29.5755 25.2322 29.7674 24.7689 29.7674 24.2858V9.71437C29.7674 9.2313 29.5755 8.76801 29.234 8.42643C28.8924 8.08484 28.4291 7.89294 27.946 7.89294ZM15.196 18.8215V15.1787H20.6603V18.8215H15.196ZM20.6603 20.6429V24.2858H15.196V20.6429H20.6603ZM7.9103 15.1787H13.3746V18.8215H7.9103V15.1787ZM15.196 13.3572V9.71437H20.6603V13.3572H15.196ZM22.4817 15.1787H27.946V18.8215H22.4817V15.1787ZM27.946 13.3572H22.4817V9.71437H27.946V13.3572ZM13.3746 9.71437V13.3572H7.9103V9.71437H13.3746ZM7.9103 20.6429H13.3746V24.2858H7.9103V20.6429ZM27.946 24.2858H22.4817V20.6429H27.946V24.2858Z" :fill="elementsViewTable ? '#C59014' : '#474849'"/>
                                    </svg>
        
                                    <svg @click="elementsViewTable = false" width="35" height="34" viewBox="0 0 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="1.14258" y="0.5" width="33" height="33" rx="5.5" stroke="#474849"/>
                                        <path d="M26.7506 17.9108H8.53627C8.0532 17.9108 7.58991 18.1027 7.24833 18.4443C6.90674 18.7859 6.71484 19.2492 6.71484 19.7322V24.2858C6.71484 24.7689 6.90674 25.2322 7.24833 25.5737C7.58991 25.9153 8.0532 26.1072 8.53627 26.1072H26.7506C27.2336 26.1072 27.6969 25.9153 28.0385 25.5737C28.3801 25.2322 28.572 24.7689 28.572 24.2858V19.7322C28.572 19.2492 28.3801 18.7859 28.0385 18.4443C27.6969 18.1027 27.2336 17.9108 26.7506 17.9108ZM26.7506 24.2858H8.53627V19.7322H26.7506V24.2858ZM26.7506 7.89294H8.53627C8.0532 7.89294 7.58991 8.08484 7.24833 8.42643C6.90674 8.76801 6.71484 9.2313 6.71484 9.71437V14.2679C6.71484 14.751 6.90674 15.2143 7.24833 15.5559C7.58991 15.8975 8.0532 16.0894 8.53627 16.0894H26.7506C27.2336 16.0894 27.6969 15.8975 28.0385 15.5559C28.3801 15.2143 28.572 14.751 28.572 14.2679V9.71437C28.572 9.2313 28.3801 8.76801 28.0385 8.42643C27.6969 8.08484 27.2336 7.89294 26.7506 7.89294ZM26.7506 14.2679H8.53627V9.71437H26.7506V14.2679Z" :fill="!elementsViewTable ? '#C59014' : '#474849'"/>
                                    </svg>
                                </div>
        
                                <!-- <div class="text-[#8C8C8C] w-[250px] text-start font-medium relative text-[14px]">
                                    Відображення елементів
                                    <span v-if="elementsViewTable" class="text-[#8FC408]">таблиця</span>
                                    <span v-else class="text-[#FA1367]">групи</span>
        
                                    
                                </div>
                                <div class="ml-[20px] relative">
                                    <IphoneSwitch :isOnValue="elementsViewTable" @change="elementsViewTable = !elementsViewTable"/>
                                </div> -->
                            </div>
                        </div>
                        <ButtonComponent @click="showElements = false" v-if="currentAdminRole != 'supervisor'">Назад</ButtonComponent>
                    </div>
                </div>

                <div v-if="elementsViewTable" class="overflow-x-auto w-full">
                    <table class="w-full mt-[40px]">
                        <thead class="text-white select-none">
                            <tr class="border-b-[1px] border-[#FFF] border-opacity-10 text-white">
                                <th class="px-3 py-2 w-[5%] text-center font-bold text-sm"></th>
                                <th class="px-3 py-2 w-[20%] text-start font-bold text-sm">Назва елементу</th>
                                <th class="px-3 py-2 w-[10%] text-center font-bold text-sm">Елемент</th>
                                <th class="px-3 py-2 w-[10%] text-end font-bold text-sm">Блок</th>
                                <th class="w-[15%] py-2 cursor-pointer select-none text-end font-bold text-sm">
                                    Тривалість
                                </th>
                                <th class="w-[5%]" ></th>
                                <th class="px-3 py-2 text-end w-[204px] relative font-bold text-sm">
                                    Направленість
                                </th>
                                <th class="px-3 w-[25%] py-2 text-end font-bold text-sm"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="element in allTrainingElements" class="border-b-[1px] border-[#FFF] border-opacity-10 text-white">
                                <td class="px-3 py-2 w-[5%] text-center font-medium text-sm">
                                    <div class="rounded-full border-[1px] bg-[#BD9135] border-white w-[50px] h-[50px] flex justify-center items-center text-center align-middle">
                                        <span class="text-[21px]">{{ element.name ? element.name[0].toUpperCase() : 'N' }}</span>
                                    </div>
                                </td>
                                <td class="px-3 py-2 w-[20%] text-start font-medium text-sm">{{ element.name ? element.name : 'Немає назви' }}</td>
                                <td class="px-3 py-2 w-[10%] text-center font-medium text-sm text-[#BD9135]">{{ parseElementType(element.type) }}</td>
                                <td class="px-3 py-2 w-[10%] text-end font-medium text-sm">{{ parseAgeGroup(element.training_program_years) }}</td>
                                <td class="w-[15%] py-2 select-none text-end font-medium text-sm">
                                    {{ element.time ?? 'Налаштовувана' }}
                                </td>
                                <td class="w-[5%]" ></td>
                                <td class="px-3 py-2 text-end relative font-medium text-sm">
                                    <!-- {{ element.element_direction ? parseElementDirection(element.element_direction) : '-' }} -->
                                    <div class="flex gap-[10px] items-center h-full">
                                        <div v-for="direction in element.detailDirection" :style="[`background-color: ${direction.color}; width: max-content;`]" class="rounded-[6px] text-white text-[12px] px-[10px] py-[3px]">
                                            {{ direction.name }} ({{ direction.percent }})
                                        </div>
                                    </div>
                                    
                                </td>
                                <td class="px-3 w-[25%] py-2 text-end font-medium text-sm">
                                    <button 
                                    class="w-[100px] py-1 rounded-[10px] text-sm font-medium text-red-600"
                                    @click="addElementToTraining(element)"
                                    >
                                    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="13" cy="13" r="13" fill="#339989"/>
                                        <line x1="13" y1="5" x2="13" y2="21" stroke="white" stroke-width="2"/>
                                        <line x1="5" y1="13" x2="21" y2="13" stroke="white" stroke-width="2"/>
                                    </svg>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-else class="my-[20px]">
                    <div v-if="!selectedGroupAgeGroup">
                        <!-- <div v-for="el in 18" @click="selectedGroupAgeGroup = `${el + 5}_years`" class="bg-[#BD9135] flex justify-center items-center w-[60%] mt-[20px] mx-auto h-[38px] cursor-pointer text-white font-semibold py-[5px] rounded-lg">
                            <span><span class="text-black">U{{el + 5}}</span></span>
                        </div>
                        <div @click="selectedGroupAgeGroup = 'main_team'" class="bg-[#BD9135] flex justify-center items-center w-[60%] mt-[20px] mx-auto h-[38px] cursor-pointer text-white font-semibold py-[5px] rounded-lg">
                            <span><span class="text-black">Основна команда</span></span>
                        </div> -->

                        <div class="">
                            <div></div>
                            <div class="grid grid-cols-5 gap-7">
                                <div 
                                    v-for="block in blockCardOptions" 
                                    :key="block"
                                    @click="selectGroup(block)" 
                                    class="bg-[#BD9135] w-[250px] h-[250px] rounded-md cursor-pointer"
                                >
                                    <div class="w-full h-[200px] flex justify-center items-center">
                                        <div>
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M11.9982 2.00012C8.99043 2.00012 7.04018 4.01911 4.73371 4.75502C3.79589 5.05425 3.32697 5.20387 3.1372 5.41477C2.94743 5.62568 2.89186 5.93387 2.78072 6.55026C1.59143 13.1461 4.1909 19.2441 10.3903 21.6176C11.0564 21.8726 11.3894 22.0001 12.0015 22.0001C12.6135 22.0001 12.9466 21.8726 13.6126 21.6176C19.8116 19.2441 22.4086 13.1461 21.219 6.55025C21.1078 5.93376 21.0522 5.62552 20.8624 5.41461C20.6726 5.2037 20.2037 5.05417 19.2659 4.75511C16.9585 4.01927 15.0061 2.00012 11.9982 2.00012Z" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M12 7.00012L12 9.00012" stroke="#000" stroke-width="1.5" stroke-linecap="round"/>
                                            </svg>
                                        </div>
                                    </div>
                                    <div class="w-full h-[50px] text-center flex justify-center items-center">
                                        <div class="text-black font-bold px-[20px]">
                                            {{ block }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class=" mx-auto mt-3 mb-5 rounded-[10px] overflow-y-auto">
                        <div @click="resetGroupSelection" class="bg-[#BD9135] flex justify-center mb-[20px] items-center w-[228px] h-[38px] cursor-pointer text-white font-semibold py-[5px] rounded-lg">
                            <span>Назад</span>
                        </div>
                        <div class="w-full overflow-x-auto">
                            <!-- <table class="w-full">
                                <thead class="text-white select-none">
                                    <tr class="border-b-[1px] border-[#FFF] border-opacity-10 text-white">
                                        <th class="px-3 py-2 w-[5%] text-center font-bold text-sm"></th>
                                        <th class="px-3 py-2 w-[20%] text-start font-bold text-sm">Назва елементу</th>
                                        <th class="px-3 py-2 w-[10%] text-center font-bold text-sm">Елемент</th>
                                        <th class="px-3 py-2 w-[10%] text-end font-bold text-sm">Блок</th>
                                        <th class="w-[15%] py-2 cursor-pointer select-none text-end font-bold text-sm">
                                            Тривалість
                                        </th>
                                        <th class="w-[5%]" ></th>
                                        <th class="px-3 py-2 text-end w-[204px] relative font-bold text-sm">
                                            Направленість
                                        </th>
                                        <th class="px-3 w-[100px] py-2 text-end font-bold text-sm"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="element in trainingElements" v-if="trainingElements.length" class="border-b-[1px] border-[#FFF] border-opacity-10 text-white">
                                        <td class="px-3 py-2 w-[5%] text-center font-medium text-sm">
                                            <div class="rounded-full border-[1px] bg-[#BD9135] border-white w-[50px] h-[50px] flex justify-center items-center text-center align-middle">
                                                <span class="text-[21px]">{{ element.name ? element.name[0].toUpperCase() : 'N' }}</span>
                                            </div>
                                        </td>
                                        <td class="px-3 py-2 w-[20%] text-start font-medium text-sm">{{ element.name ? element.name : 'Немає назви' }}</td>
                                        <td class="px-3 py-2 w-[10%] text-center font-medium text-sm text-[#BD9135]">{{ parseElementType(element.type) }}</td>
                                        <td class="px-3 py-2 w-[10%] text-end font-medium text-sm">{{ parseAgeGroup(element.training_program_years) }}</td>
                                        <td class="w-[15%] py-2 select-none text-end font-medium text-sm">
                                            {{ element.time ?? 'Налаштовувана' }}
                                        </td>
                                        <td class="w-[5%]" ></td>
                                        <td class="px-3 py-2 text-end w-[204px] relative font-medium text-sm">
                                            <div class="flex justify-start gap-[5px] w-[600px] overflow-auto">
                                                <div v-for="direction in element.detailDirection" :style="[`background-color: ${direction.color}; width: max-content;`]" class="rounded-[6px] text-white text-[12px] px-[10px] py-[3px]">
                                                    {{ direction.name }} ({{ (+direction?.percent).toFixed(2) }})
                                                </div>
                                            </div>
                                        </td>
                                        <td class="px-3 w-[100px] py-2 text-end font-medium text-sm">
                                            <button 
                                            class="py-1 w-[100px] rounded-[10px] text-sm font-medium text-red-600"
                                            @click="addElementToTraining(element)"
                                            >
                                            <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="13" cy="13" r="13" fill="#339989"/>
                                                <line x1="13" y1="5" x2="13" y2="21" stroke="white" stroke-width="2"/>
                                                <line x1="5" y1="13" x2="21" y2="13" stroke="white" stroke-width="2"/>
                                            </svg>
                                            </button>
                                        </td>
                                    </tr>
                                    <tr v-else>
                                        <td class="px-3 py-2 w-[20%] text-center font-bold text-white" colspan="8">Немає елементів</td>
                                    </tr>
                                </tbody>
                            </table> -->

                            <div class="elements-grid">
                                <div v-for="element in trainingElements" v-if="trainingElements.length" class="elements-card w-full cursor-pointer flex flex-col justify-between">
                                    <div>
                                        <YouTube 
                                            v-if="element.additional_videos[0]"
                                            :src="element.additional_videos[0]" 
                                            :key="element.additional_videos[0]"
                                            class="w-full"
                                            height="150px"
                                            width="100%"
                                            ref="youtube" 
                                        />
                                        <h3 class="text-lg font-semibold">{{ element.name ? element.name : 'Немає назви' }}</h3>
                                        <div class="direction-grid">
                                            <div v-for="direction in element.detailDirection" :style="[`background-color: ${direction.color}; width: max-content;`]" class="rounded-[6px] text-white text-[10px] px-[10px] py-[1.5px]">
                                                {{ direction.name }} ({{ (+direction?.percent).toFixed(2) }})
                                            </div>
                                        </div>
                                    </div>
                                    <div class="w-full flex justify-center">
                                        <button 
                                            class="py-1 rounded-[10px] text-sm font-medium text-red-600"
                                            @click="addElementToTraining(element)"
                                        >
                                            <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="13" cy="13" r="13" fill="#339989"/>
                                                <line x1="13" y1="5" x2="13" y2="21" stroke="white" stroke-width="2"/>
                                                <line x1="5" y1="13" x2="21" y2="13" stroke="white" stroke-width="2"/>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div v-else-if="elementViewFlag" class="mt-[100px]">
                <ElementView @back="elementViewFlag = false" @changeTime="changeTimeSelectedElement" @deleteElement="deleteElementFromTimeline" :element="selectedElement" :canDelete="!(isGoalkeeperTrainer && activeTimeline === 'player')" />
            </div>
        </div> 
    </div>
</template>

<script>
    import { ref, onMounted, computed, watch, watchEffect } from 'vue'
    import { addTrainingRequest, getAllTrainingElementsRequest, getPlanedTrainingsByDate, addNewTrainingSummary, getStatisticsByElements, getAllTrainingPrograms } from '@/desktopApp/services/apiRequests'
    import { useMainStore } from '@/desktopApp/stores/mainStore'
    import ElementView from './ElementView.vue'
    import draggable from 'vuedraggable'
    import ElementFilter from './ElementFilter.vue'
    import IphoneSwitch from './IphoneSwitch.vue'
    import YouTube from 'vue3-youtube';

    export default {
        name: 'TrainingForm',

        props: {
            summary: {
                type: Object,
                default: () => ({})
            }
        },

        setup(props, { emit }) {
            const ageGroup = ref('6_years')
            const showElements = ref(false)

            const allTrainingElements = ref([])
            const elements = ref(props.summary?.elements ? props.summary?.elements : [])
            const goalkeeperElements = ref(props.summary?.goalkeeper_elements ? props.summary?.goalkeeper_elements : [])
            const minutes = ref(0)
            const hours = ref(0)

            const activeTimeline = ref('player')
            const selectedElement = ref({})

            const elementViewFlag = ref(false)

            const trainingName = ref(props.summary?.name ? props.summary?.name : '')
            const trainingDescription = ref(props.summary?.info ? props.summary?.info : '')
            const trainingAgeGroup = ref(props.summary?.age_group ? props.summary?.age_group : '')

            const errorValidationFlag = ref(false)

            const searchQuery = ref('')

            const page = ref(1)
            const maxPage = ref(1)

            const workload = ref(props.summary?.workload ? props.summary?.workload : '')
            const inventory = ref(props.summary?.inventory ? props.summary?.inventory : '')
            const theme = ref(props.summary?.theme ? props.summary?.theme : '')
            const direction = ref(props.summary?.direction ? props.summary?.direction : '')

            const elementsViewTable = ref(false)

            const trainingOrientation = ref(props.summary?.trainingOrientation ? props.summary?.trainingOrientation : [])

            const filters = ref({
                elementType: 'all',
                ageCategory: 'all',
                assessmentType: 'all',
                direction: 'all',
                timeSort: 'none',
            })

            const countElementsDirections = ref({
                physical: 0,
                technical: 0,
                tactical: 0,
                tech_tactical: 0
            })

            const parseElementDirection = (direction) => {
                switch (direction) {
                    case 'physical':
                        return 'Фізичне'
                    case 'tactical':
                        return 'Тактичне'
                    case 'technical':
                        return 'Технічне'
                    case 'tech_tactical':
                        return 'Техніко/тактичне'
                    default:
                        return 'Невідома направленість'
                }
            }

            // watch(() => elements.length, () => {
            //     countElementsDirections.value.physical = elements.filter(el => el.direction == 'physical').length
            //     countElementsDirections.value.technical = elements.filter(el => el.direction == 'technical').length
            //     countElementsDirections.value.tactical = elements.filter(el => el.direction == 'tactical').length

            //     direction.value = Object.keys(countElementsDirections.value).reduce((a, b) => countElementsDirections.value[a] > countElementsDirections.value[b] ? a : b)

            //     console.log(countElementsDirections.value)
            // })

            const selectedGroupAgeGroup = ref(null)
            const selectedGroupElementType = ref('task')
            const selectedElementDirection = ref('all')
            const trainingElements = ref([])

            const store = useMainStore()

            const isMethodist = computed(() => {
                const position = (store.trainer_position || '').toLowerCase()
                return position.includes('метод') || position.includes('method')
            })

            const isGoalkeeperTrainer = computed(() => {
                const position = (store.trainer_position || '').toLowerCase()
                return position.includes('goalkeeper_trainer')
            })

            const isIndividualTrainer = computed(() => {
                const position = (store.trainer_position || '').toLowerCase()
                return position.includes('individual_trainer')
            })

            const canEditGoalkeeperTimeline = computed(() => {
                return isMethodist.value || isGoalkeeperTrainer.value || isIndividualTrainer.value
            })

            const blockCardOptions = computed(() => {
                return isGoalkeeperTrainer.value
                    ? [
                        'Захист воріт',
                        'Захист зони',
                        'Захист простору',
                        'Гра 1VS1',
                        'Початок атаки + пас назад',
                        'Спортзал'
                    ]
                    : [
                        'Блок оборони-атаки',
                        'Блок малі групи',
                        'Блок великі групи',
                        'Блок квадратів',
                        'Блок удари-завершення',
                        'Блок технічний',
                        'Блок тактичний',
                        'Блок профілактики травматизму/зміцнення',
                        'Блок швидкісно-силової спрямованості',
                        'Блок спеціальної витривалості',
                        'Домашнє завдання',
                        'Блок швидких атак',
                        'Спортзал'
                    ]
            })

            watch(elementsViewTable, async (value) => {
                filters.value = {
                    elementType: 'all',
                    ageCategory: 'all',
                    assessmentType: 'all',
                    direction: 'all',
                    timeSort: 'none',
                }

                selectedGroupAgeGroup.value = null
                selectedGroupElementType.value = 'task'
                selectedElementDirection.value = 'all'

                await updateElements()
            })

            const selectGroup = (block) => {
                selectedGroupElementType.value = 'task'
                selectedElementDirection.value = 'all'
                selectedGroupAgeGroup.value = block
            }

            const resetGroupSelection = () => {
                selectedGroupAgeGroup.value = null
                selectedGroupElementType.value = 'task'
                selectedElementDirection.value = 'all'
                trainingElements.value = []
            }

            watch(selectedGroupAgeGroup, async (value) => {
                if (value) {
                    trainingElements.value = []
                    const response = await getAllTrainingElementsRequest(20 * page.value, 20 * (page.value - 1), {
                        elementType: selectedGroupElementType.value ?? 'task',
                        ageCategory: selectedGroupAgeGroup.value ?? 'all',
                        assessmentType: 'all',
                        direction: selectedElementDirection.value ?? 'all',
                        timeSort: 'none',
                    }, searchQuery.value)
                    filters.value = {
                        elementType: selectedGroupElementType.value ?? 'task',
                        ageCategory: selectedGroupAgeGroup.value ?? 'all',
                        assessmentType: 'all',
                        direction: selectedElementDirection.value ?? 'all',
                        timeSort: 'none',
                    }
                    trainingElements.value = response
                }
            })

            watch(selectedGroupElementType, async (value) => {
                if (value) {
                    trainingElements.value = []
                    const response = await getAllTrainingElementsRequest(20 * page.value, 20 * (page.value - 1), {
                        elementType: selectedGroupElementType.value ?? 'all',
                        ageCategory: selectedGroupAgeGroup.value ?? 'all',
                        assessmentType: 'all',
                        direction: selectedElementDirection.value ?? 'all',
                        timeSort: 'none',
                    }, searchQuery.value)
                    filters.value = {
                        elementType: selectedGroupElementType.value ?? 'all',
                        ageCategory: selectedGroupAgeGroup.value ?? 'all',
                        assessmentType: 'all',
                        direction: selectedElementDirection.value ?? 'all',
                        timeSort: 'none',
                    }
                    console.log('filters.value ------- ', filters.value)
                    trainingElements.value = response
                    console.log('trainingElements.value ------- ', response)
                }
            })
            watch(selectedElementDirection, async (value) => {

                if (value) {
                    trainingElements.value = []
                    const response = await getAllTrainingElementsRequest(20 * page.value, 20 * (page.value - 1), {
                        elementType: selectedGroupElementType.value ?? 'all',
                        ageCategory: selectedGroupAgeGroup.value ?? 'all',
                        assessmentType: 'all',
                        direction: selectedElementDirection.value ?? 'all',
                        timeSort: 'none',
                    }, searchQuery.value)
                    filters.value = {
                        elementType: selectedGroupElementType.value ?? 'all',
                        ageCategory: selectedGroupAgeGroup.value ?? 'all',
                        assessmentType: 'all',
                        direction: selectedElementDirection.value ?? 'all',
                        timeSort: 'none',
                    }
                    console.log('filters.value ------- ', filters.value)
                    trainingElements.value = response
                    console.log('trainingElements.value ------- ', response)
                }
            })

            

            const filterFlag = ref(false)

            const prevPage = () => {
                page.value > 1 ? page.value-- : page.value = 1
            }

            const nextPage = () => {
                maxPage.value >= page.value + 1 ? page.value++ : page.value = maxPage.value
            }

            watch(page, async (value) => {
                await updateElements()
            })

            watch(searchQuery, async (value) => {
                await updateElements()
            })

            const setFilters = async (newFilters) => {
                filters.value = newFilters
                filterFlag.value = false

                console.log(filters.value)

                await updateElements()
            }

            const dropFilters = async () => {
                filters.value = {
                    elementType: 'all',
                    ageCategory: 'all',
                    assessmentType: 'all',
                    direction: 'all',
                    timeSort: 'none',
                }
                filterFlag.value = false

                await updateElements()
            }

            watch(page, async (newValue) => {
                trainingElements.value = []
                const response = await getAllTrainingElementsRequest(20 * page.value, 20 * (page.value - 1), filters.value, searchQuery.value)
                allTrainingElements.value = response
            })

            const updateElements = async () => {
                const response = await getAllTrainingElementsRequest(20 * page.value, 20 * (page.value - 1), filters.value, searchQuery.value)
                allTrainingElements.value = response
                trainingElements.value = response
                console.log('allTrainingElements.value ------- ', response)
            }

            const validation = ref({
                name: true,
                ageGroup: true,
                description: true,
                exercises: true
            })

            watch(() => trainingName.value, (newValue) => {
                validation.value.name = !!newValue
            })

            watch(() => trainingAgeGroup.value, (newValue) => {
                validation.value.ageGroup = !!newValue
            })

            watch(() => trainingDescription.value, (newValue) => {
                validation.value.description = !!newValue
            })

            const checkValidation = () => {
                if (!trainingName.value) {
                    validation.value.name = false
                } else {
                    validation.value.name = true
                }

                if (!trainingAgeGroup.value) {
                    validation.value.ageGroup = false
                } else {
                    validation.value.ageGroup = true
                }

                // if (!trainingDescription.value) {
                //     validation.value.description = false
                // } else {
                //     validation.value.description = true
                // }

                if (!elements.value.length) {
                    validation.value.exercises = false
                } else {
                    validation.value.exercises = true
                }

                if (elements.value.some(el => !el.time)) {
                    validation.value.exercises = false
                } else { 
                    validation.value.exercises = true
                }
            }

            const timelineTime = computed(() => {
                let minutesTimeline = 0
                let hoursTimeline = 0 
                elements.value.forEach(el => {
                    minutesTimeline += +el.time
                })

                if (minutesTimeline >= 60) {
                    hoursTimeline += Math.floor(minutesTimeline / 60)
                    minutesTimeline = minutesTimeline % 60
                }

                return `${hoursTimeline}:${minutesTimeline}`
            })

            const allPrograms = ref([])
            const selectedProgram = ref(null)
            const selectedProgramName = ref('')

            const allSeasons = ref([])
            const selectedSeason = ref(props.summary.season_id ? props.summary.season_id : null)
            const selectedSeasonName = ref('')

            const allMesocycles = ref([])
            const selectedMesocycle = ref(props.summary.mesocycle_id ? props.summary.mesocycle_id : null)
            const selectedMesocycleName = ref('')

            const allMicrocycles = ref([])
            const selectedMicrocycle = ref(props.summary.microcycle_id ? props.summary.microcycle_id : null)
            const selectedMicrocycleName = ref('')

            watch(selectedProgram, (newValue) => {
                allPrograms.value.forEach(program => {
                    if (program.id == newValue) {
                        allSeasons.value = program.seasons
                        selectedProgramName.value = program.name
                        selectedSeason.value = props.summary.season_id ? props.summary.season_id : null
                        allMesocycles.value = []
                        selectedMesocycle.value = props.summary.mesocycle_id ? props.summary.mesocycle_id : null
                        allMicrocycles.value = []
                        selectedMicrocycle.value = props.summary.microcycle_id ? props.summary.microcycle_id : null
                    }
                })
            })

            watch(selectedSeason, (newValue) => {
                allPrograms.value.forEach(program => {
                    program.seasons.forEach(season => {
                        if (season.id == newValue) {
                            allMesocycles.value = program.mesocycles.filter(mesocycle => mesocycle.season_id == newValue)
                            selectedSeasonName.value = season.name
                            selectedMesocycle.value = null
                            allMicrocycles.value = []
                            selectedMicrocycle.value = null
                        }
                    })
                })
            })

            watch(selectedMesocycle, (newValue) => {
                allPrograms.value.forEach(program => {
                    program.mesocycles.forEach(mesocycle => {
                        if (mesocycle.id == newValue) {
                            allMicrocycles.value = program.microcycles.filter(microcycle => microcycle.mesocycle_id == newValue)
                            selectedMicrocycle.value = null
                            selectedMesocycleName.value = mesocycle.name
                        }
                    })
                })
            })

            watch(selectedMicrocycle, (newValue) => {
                allPrograms.value.forEach(program => {
                    program.microcycles.forEach(microcycle => {
                        if (microcycle.id == newValue) {
                            selectedMicrocycleName.value = microcycle.name
                        }
                    })
                })
            })

            onMounted(async () => {
                const response = await getAllTrainingElementsRequest(20 * page.value, 20 * (page.value - 1), filters.value, searchQuery.value)
                allTrainingElements.value = response

                const programsResponse = await getAllTrainingPrograms()
                allPrograms.value = programsResponse
                console.log('allPrograms.value ------- ', allPrograms.value)

                const statistics = await getStatisticsByElements()

                maxPage.value = Math.ceil((statistics.standard + statistics.exercise + statistics.task) / 20)

                const allOrientations = []
                
                elements.value.forEach(el => {
                    if (!el.detailDirection || !el.detailDirection.length) return
                    el.detailDirection.forEach(direction => {
                        const maybeCurrentOrientation = allOrientations.find(e => e.id == direction.id)
                        if (!maybeCurrentOrientation) {
                            allOrientations.push({
                                id: direction.id,
                                name: direction.name,
                                count: 1,
                                percentages: [
                                    +direction.percent
                                ],
                                color: direction.color,
                                averagePercent: +direction.percent
                            })
                        } else {
                            maybeCurrentOrientation.count += 1
                            maybeCurrentOrientation.percentages.push(+direction.percent)
                            maybeCurrentOrientation.averagePercent = maybeCurrentOrientation.percentages.reduce((a, b) => a + b, 0) / maybeCurrentOrientation.percentages.length
                        }
                    })
                })

                const trainerGroupAge = store.trainer_groups[0].name.split('U')[1]
                console.log('trainer group orientations ---------> ', store.trainer_groups[0])
                trainingAgeGroup.value = trainerGroupAge ? `${trainerGroupAge}_years` : null

                const currentProgramByGroup = allPrograms.value.find(program => program.groups.includes(store.trainer_groups[0].group_id))
                selectedProgram.value = currentProgramByGroup ? currentProgramByGroup.id : null

                console.log('allOrientations ---------> ', allOrientations)
                trainingOrientation.value = allOrientations
            })

            const getGkElementsWithPositions = () => {
                return goalkeeperElements.value.map(el => ({
                    ...el,
                    timeline_position: gkPositionMap.value[el.current_id] ?? 0
                }))
            }

            const addTraining = async () => {
                checkValidation()

                if (!Object.values(validation.value).some(el => !el)) {
                    emit('saveTraining', {
                        name: trainingName.value,
                        info: trainingDescription.value,
                        age_group: trainingAgeGroup.value,
                        elements: elements.value,
                        goalkeeper_elements: getGkElementsWithPositions(),
                        workload: workload.value,
                        inventory: inventory.value,
                        theme: theme.value,
                        direction: direction.value,
                        trainingOrientation: trainingOrientation.value,

                        program_name: selectedProgramName.value,
                        program_id: selectedProgram.value,
                        mesocycle_id: selectedMesocycle.value,
                        mesocycle_name: selectedMesocycleName.value,
                        microcycle_id: selectedMicrocycle.value,
                        microcycle_name: selectedMicrocycleName.value,
                    })
                } else {
                    console.log('Validation error')
                    errorValidationFlag.value = true
                }
            }

            const addElementToTraining = async (elementObject) => {
                const targetArray = activeTimeline.value === 'goalkeeper' ? goalkeeperElements : elements
                targetArray.value.push(Object.assign({}, elementObject))
                const addedElement = targetArray.value[targetArray.value.length - 1]
                addedElement.current_id = targetArray.value.length
                if (addedElement.approaches_break == null || addedElement.approaches_break === '') {
                    addedElement.approaches_break = 0
                }
                minutes.value += +elementObject?.time
                if (minutes.value >= 60) {
                    hours.value += Math.floor(minutes.value / 60)
                    minutes.value = minutes.value % 60
                }

                countElementsDirections.value.physical = elements.value.filter(el => el.element_direction == 'physical').length
                countElementsDirections.value.technical = elements.value.filter(el => el.element_direction == 'technical').length
                countElementsDirections.value.tactical = elements.value.filter(el => el.element_direction == 'tactical').length
                countElementsDirections.value.tech_tactical = elements.value.filter(el => el.element_direction == 'tech_tactical').length

                if (countElementsDirections.value.physical > countElementsDirections.value.technical && countElementsDirections.value.physical > countElementsDirections.value.tactical) {
                    direction.value = 'physical'
                } else if (countElementsDirections.value.technical > countElementsDirections.value.physical && countElementsDirections.value.technical > countElementsDirections.value.tactical) {
                    direction.value = 'technical'
                } else if (countElementsDirections.value.tactical > countElementsDirections.value.physical && countElementsDirections.value.tactical > countElementsDirections.value.technical) {
                    direction.value = 'tactical'
                } else if (countElementsDirections.value.tech_tactical > countElementsDirections.value.physical && countElementsDirections.value.tech_tactical > countElementsDirections.value.technical && countElementsDirections.value.tech_tactical > countElementsDirections.value.tactical) {
                    direction.value = 'tech_tactical'
                }

                const allOrientations = []
                
                elements.value.forEach(el => {
                    if (!el.detailDirection || !el.detailDirection.length) return
                    el.detailDirection.forEach(direction => {
                        const maybeCurrentOrientation = allOrientations.find(e => e.id == direction.id)
                        if (!maybeCurrentOrientation) {
                            allOrientations.push({
                                id: direction.id,
                                name: direction.name,
                                count: 1,
                                percentages: [
                                    +direction.percent
                                ],
                                color: direction.color,
                                averagePercent: +direction.percent
                            })
                        } else {
                            maybeCurrentOrientation.count += 1
                            maybeCurrentOrientation.percentages.push(+direction.percent)
                            maybeCurrentOrientation.averagePercent = maybeCurrentOrientation.percentages.reduce((a, b) => a + b, 0) / maybeCurrentOrientation.percentages.length
                        }
                    })
                })

                console.log('allOrientations ---------> ', allOrientations)
                trainingOrientation.value = allOrientations

                console.log(countElementsDirections.value)
            }

            const parseElementType = (type) => {
                switch (type) {
                    case 'standard':
                        return 'Норматив'
                    case 'exercise':
                        return 'Вправа'
                    case 'task':
                        return 'Завдання'
                    default:
                        return 'Невідомий тип елементу'
                }
            }

            const parseAgeGroup = (ageGroup) => {
                switch (ageGroup) {
                    case '6_years':
                        return 'Невідомий блок'
                    case '7_years':
                        return 'Невідомий блок'
                    case '8_years':
                        return 'Невідомий блок'
                    case '9_years':
                        return 'Невідомий блок'
                    case '10_years':
                        return 'Невідомий блок'
                    case '11_years':
                        return 'Невідомий блок'
                    case '12_years':
                        return 'Невідомий блок'
                    case '13_years':
                        return 'Невідомий блок'
                    case '14_years':
                        return 'Невідомий блок'
                    case '15_years':
                        return 'Невідомий блок'
                    case '16_years':
                        return 'Невідомий блок'
                    case '17_years':
                        return 'Невідомий блок'
                    case '18_years':
                        return 'Невідомий блок'
                    case '19_years':
                        return 'Невідомий блок'
                    case '20_years':
                        return 'Невідомий блок'
                    case '21_years':
                        return 'Невідомий блок'
                    case '22_years':
                        return 'Невідомий блок'
                    case '23_years':
                        return 'Невідомий блок'
                    case 'main_team':
                        return 'Невідомий блок'
                    default:
                        return ageGroup
                }
            }

            const parseScoring = (scoring) => {
                switch (scoring) {
                    case 'time':
                        return 'Час'
                    case 'point':
                        return 'Оцінка'
                    case 'length':
                        return 'Відстань'
                    default:
                        return '-'
                }
            }

            const deleteElementFromTimeline = (element, timeline) => {
                const targetArray = timeline === 'goalkeeper' ? goalkeeperElements : elements
                const index = targetArray.value.indexOf(element)
                if (index !== -1) {
                    targetArray.value.splice(index, 1)
                }
                minutes.value -= +element?.time
                if (minutes.value < 0) {
                    hours.value -= Math.floor(minutes.value / 60)
                    minutes.value = 60 + (minutes.value % 60)
                }
                elementViewFlag.value = false
                selectedElement.value = {}
            }

            const getFulltimeOfElements = () => {
                let minutes = 0
                elements.value.forEach(el => {
                    minutes += +el.time
                })
                return minutes
            }

            const isElementsWithoutTime = () => {
                return elements.value.some(el => !el.time)
            }

            const getFulltimeOfGoalkeeperElements = () => {
                let minutes = 0
                goalkeeperElements.value.forEach(el => {
                    minutes += +el.time
                })
                return minutes
            }

            const isGoalkeeperElementsWithoutTime = () => {
                return goalkeeperElements.value.some(el => !el.time)
            }

            const goalkeeperTimelineTime = computed(() => {
                let minutesTimeline = 0
                let hoursTimeline = 0 
                goalkeeperElements.value.forEach(el => {
                    minutesTimeline += +el.time
                })
                if (minutesTimeline >= 60) {
                    hoursTimeline += Math.floor(minutesTimeline / 60)
                    minutesTimeline = minutesTimeline % 60
                }
                return `${hoursTimeline}:${minutesTimeline}`
            })

            const syncLayout = computed(() => {
                const pElems = elements.value
                const gElems = goalkeeperElements.value

                if (pElems.length === 0 || gElems.length === 0) return null
                if (pElems.some(el => !el.time) || gElems.some(el => !el.time)) return null

                const totalTime = pElems.reduce((s, el) => s + (+el.time), 0)
                    + gElems.reduce((s, el) => s + (+el.time), 0)

                return { totalTime }
            })

            const gkPositionMap = ref({})
            goalkeeperElements.value.forEach(el => {
                if (el.timeline_position !== undefined) {
                    gkPositionMap.value[el.current_id] = el.timeline_position
                }
            })
            const draggingGkId = ref(null)

            const getGkElementWidth = (element) => {
                if (syncLayout.value) {
                    return (+element.time / syncLayout.value.totalTime) * 100
                }
                const fullTime = getFulltimeOfGoalkeeperElements()
                if (!fullTime || isGoalkeeperElementsWithoutTime()) {
                    return 100 / Math.max(1, goalkeeperElements.value.length)
                }
                return (+element.time / fullTime) * 100
            }

            const getGkPosition = (element) => {
                if (gkPositionMap.value[element.current_id] === undefined) {
                    let maxRight = 0
                    goalkeeperElements.value.forEach(el => {
                        if (el.current_id !== element.current_id && gkPositionMap.value[el.current_id] !== undefined) {
                            maxRight = Math.max(maxRight, gkPositionMap.value[el.current_id] + getGkElementWidth(el))
                        }
                    })
                    gkPositionMap.value[element.current_id] = Math.min(maxRight, 100 - getGkElementWidth(element))
                }
                return gkPositionMap.value[element.current_id]
            }

            const getGkRailStyle = (element) => {
                const width = getGkElementWidth(element)
                const left = getGkPosition(element)
                return {
                    width: width + '%',
                    left: left + '%'
                }
            }

            const startDragGk = (event, element) => {
                if (event.button !== 0) return
                const container = event.target.closest('.line')
                if (!container) return
                const rect = container.getBoundingClientRect()
                const startX = event.clientX
                const startLeft = getGkPosition(element)
                const width = getGkElementWidth(element)
                draggingGkId.value = element.current_id
                let moved = false

                const onMouseMove = (e) => {
                    moved = true
                    const dx = e.clientX - startX
                    const dxPercent = (dx / rect.width) * 100
                    let newLeft = startLeft + dxPercent
                    newLeft = Math.max(0, Math.min(100 - width, newLeft))
                    gkPositionMap.value = { ...gkPositionMap.value, [element.current_id]: newLeft }
                }

                const onMouseUp = () => {
                    draggingGkId.value = null
                    if (!moved) {
                        elementViewFlag.value = true
                        selectedElement.value = element
                        activeTimeline.value = 'goalkeeper'
                    }
                    document.removeEventListener('mousemove', onMouseMove)
                    document.removeEventListener('mouseup', onMouseUp)
                }

                document.addEventListener('mousemove', onMouseMove)
                document.addEventListener('mouseup', onMouseUp)
            }

            const getPlayerElementStyle = (element) => {
                if (isElementsWithoutTime()) {
                    return { width: (100 / elements.value.length) + '%' }
                }
                return { width: ((100 * element.time) / getFulltimeOfElements()) + '%' }
            }

            const getElementDisplayName = (element) => {
                if (syncLayout.value) {
                    const widthPct = (+element.time / syncLayout.value.totalTime) * 100
                    return widthPct > 8 ? element.name : element.name[0]
                }
                return element.name
            }

            const changeTimeSelectedElement = (time) => {
                minutes.value -= +selectedElement.value.time
                minutes.value += +time
                if (minutes.value >= 60) {
                    hours.value += Math.floor(minutes.value / 60)
                    minutes.value = minutes.value % 60
                }
                selectedElement.value.time = time
            }

            const updateTrainingSummary = () => {
                checkValidation()
                if (!Object.values(validation.value).some(el => !el)) {
                    const newTrainingObject = {
                        name: trainingName.value,
                        info: trainingDescription.value,
                        age_group: trainingAgeGroup.value,
                        elements: elements.value,
                        goalkeeper_elements: getGkElementsWithPositions(),
                        workload: workload.value,
                        inventory: inventory.value,
                        theme: theme.value,
                        direction: direction.value,
                        trainingOrientation: trainingOrientation.value,

                        program_name: selectedProgramName.value,
                        program_id: selectedProgram.value,
                        mesocycle_id: selectedMesocycle.value,
                        mesocycle_name: selectedMesocycleName.value,
                        microcycle_id: selectedMicrocycle.value,
                        microcycle_name: selectedMicrocycleName.value,
                    } 
                    emit('saveTraining', {training: newTrainingObject, event: selectedTrainingEvent.value})
                } else {
                    console.log('Validation error')
                    errorValidationFlag.value = true
                }
            }

            const currentAdminRole = ref(localStorage.getItem('userType'))
            const nameValidationText = ref('')

            watch(trainingName, () => {
                const value = (trainingName.value || '').trim()
                const errors = []

                nameValidationText.value = ""

                if (!value) {
                    return
                }

                const datePart = value.slice(-10)
                const homeworkPattern = /^(ЗП|ПП|ПрП)\.(З|Л)\.ДЗ\.\d{2}\.\d{2}\.\d{4}$/

                if (homeworkPattern.test(value)) {
                    if (!/^\d{2}\.\d{2}\.\d{4}$/.test(datePart)) {
                        errors.push("❌ [4] Дата повинна бути у форматі ДД.ММ.РРРР")
                        nameValidationText.value += "❌ [4] Дата повинна бути у форматі ДД.ММ.РРРР<br>"
                    } else {
                        const [d, m, y] = datePart.split(".").map(Number)
                        const date = new Date(y, m - 1, d)
                        if (date.getFullYear() !== y || date.getMonth() + 1 !== m || date.getDate() !== d) {
                            errors.push("❌ [4] Некоректна дата (наприклад 31.02.2025)")
                            nameValidationText.value += "❌ [4] Некоректна дата (наприклад 31.02.2025)<br>"
                        }
                    }
                } else {
                    const parts = value.split(".")
                    parts[4] = datePart

                    if (!/^(ЗП|ПП|ПрП)$/.test(parts[0])) {
                        errors.push("❌ [1] Період має бути 'ЗП' або 'ПП' або 'ПрП'")
                        nameValidationText.value += "❌ [1] Період має бути 'ЗП' або 'ПП' або 'ПрП'<br>"
                    }

                    if (!/^[ОЗВЛ]$/.test(parts[1])) {
                        errors.push("❌ [2] Пора року повинна бути однією літерою (О, З, В, Л)")
                        nameValidationText.value += "❌ [2] Пора року повинна бути однією літерою (О, З, В, Л)<br>"
                    }

                    if (!/^Т([1-9]|1[0-9]|20)$/.test(parts[2])) {
                        errors.push("❌ [3] Тиждень повинен бути у форматі Т1–Т20")
                        nameValidationText.value += "❌ [3] Тиждень повинен бути у форматі Т1–Т20<br>"
                    }

                    if (!/^MD-(?:[1-9]|10)?$/.test(parts[3])) {
                        errors.push("❌ [4] Матч дей повинен бути у форматі MD-1..MD-10 або MD-")
                        nameValidationText.value += "❌ [4] Матч дей повинен бути у форматі MD-1..MD-10 або MD-<br>"
                    }

                    if (!/^\d{2}\.\d{2}\.\d{4}$/.test(parts[4])) {
                        errors.push("❌ [5] Дата повинна бути у форматі ДД.ММ.РРРР")
                        nameValidationText.value += "❌ [5] Дата повинна бути у форматі ДД.ММ.РРРР<br>"
                    } else {
                        const [d, m, y] = parts[4].split(".").map(Number)
                        const date = new Date(y, m - 1, d)
                        if (date.getFullYear() !== y || date.getMonth() + 1 !== m || date.getDate() !== d) {
                            errors.push("❌ [5] Некоректна дата (наприклад 31.02.2025)")
                            nameValidationText.value += "❌ [5] Некоректна дата (наприклад 31.02.2025)<br>"
                        }
                    }
                }

                if (errors.length === 0) {
                    console.log("✅ Все ок");
                    nameValidationText.value = "✅ Все ок";
                } else {
                    console.clear();
                    console.log(errors.join("\n"));
                }
            })

            const trainingDate = ref(props.summary?.date ? props.summary?.date : '')
            const trainingsByDate = ref([])
            const selectedTrainingEvent = ref(null)

            watch(trainingDate, async (newValue) => {
                if (newValue) {
                    const dateObject = new Date(newValue)
                    trainingsByDate.value = (await getPlanedTrainingsByDate(dateObject)).data
                }
            })

            const selectTrainingEvent = (training) => {
                selectedTrainingEvent.value = training
            }

            return {
                ageGroup,
                showElements,
                allTrainingElements,
                addTraining,
                parseElementType,
                parseAgeGroup,
                parseScoring,
                addElementToTraining,
                elements,
                goalkeeperElements,
                activeTimeline,
                minutes,
                hours,
                elementViewFlag,
                selectedElement,
                deleteElementFromTimeline,
                getFulltimeOfElements,
                isElementsWithoutTime,
                getFulltimeOfGoalkeeperElements,
                isGoalkeeperElementsWithoutTime,
                goalkeeperTimelineTime,
                syncLayout,
                getPlayerElementStyle,
                getElementDisplayName,
                getGkRailStyle,
                startDragGk,
                draggingGkId,
                changeTimeSelectedElement,
                timelineTime,
                trainingName,
                trainingDescription,
                trainingAgeGroup,
                updateTrainingSummary,
                validation,
                errorValidationFlag,
                page,
                maxPage,
                prevPage,
                nextPage,
                searchQuery,
                filters,
                setFilters,
                dropFilters,
                filterFlag,
                updateElements,
                workload,
                inventory,
                theme,
                direction,
                parseElementDirection,
                elementsViewTable,
                selectedGroupAgeGroup,
                selectedGroupElementType,
                selectedElementDirection,
                countElementsDirections,
                checkValidation,
                trainingElements,
                currentAdminRole,
                trainingOrientation,
                nameValidationText,
                allPrograms,
                selectedProgram,
                allSeasons,
                selectedSeason,
                allMesocycles,
                selectedMesocycle,
                allMicrocycles,
                selectedMicrocycle,
                trainingDate,
                trainingsByDate,
                selectTrainingEvent,
                selectedTrainingEvent,
                isGoalkeeperTrainer,
                isIndividualTrainer,
                canEditGoalkeeperTimeline,
                blockCardOptions,
                selectGroup,
                resetGroupSelection,
            }
        },

        components: {
            ElementView,
            draggable,
            ElementFilter,
            IphoneSwitch,
            YouTube
        }
    }
</script>

<style lang="scss" scoped>
    .training-form-content {
        // mt-4 text-start flex
        margin-top: 4rem;
        text-align: start;
        display: flex;

        & > div:first-child {
            width: 70%;
        }

        & > div:last-child {
            width: 30%;
        }
    }

    @media (max-width: 850px) {
        .training-form-content {
            flex-direction: column;

            & > div:first-child {
                width: 100%;
            }

            & > div:last-child {
                width: 100%;
                margin-bottom: 2rem;
            }
        }
    }

    .search-bar {
        display: flex;
        gap: 10px;
    }

    .search-header__sub-row {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .search-header__row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 10px;
    }

    @media screen and (max-width: 1450px) {
        .search-bar {
            flex-direction: column;
            align-items: center;
        }
    }

    @media screen and (max-width: 1150px) {
        .search-bar {
            flex-direction: column;
            align-items: center;
        }

        .search-header__sub-row {
            flex-direction: column;
            align-items: center;
        }
    }

    @media screen and (max-width: 890px) {
        .search-header__row {
            flex-direction: column;
            align-items: center;
        }
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        /* display: none; <- Crashes Chrome on hover */
        -webkit-appearance: none;
        margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
    }

    input[type=number] {
        -moz-appearance:textfield; /* Firefox */
    }

    .elements-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
        gap: 20px;
        margin-top: 20px;
    }

    .direction-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
        gap: 10px;
        margin-top: 10px;
    }
</style>
